// 是否打开购售电
export const IS_BUY_SAL_ELECTRIC_ENABLE = false;

// 高德地图配置
export const AMap = {
    accessKey: "0130cc250651b4e5adfab3e1d0699026",
    default: {
        center: {
            longitude: 120.2483083064,
            latitude: 30.2497224822,
        },
        zoom: 15
    }
};
